import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TagWithCategory } from '@molecules/TagMenu';
import React from 'react';
import styles from './TabTitleRender.module.css';

export interface ITabConfig<T> {
  icon: IconName;
  title: string | React.ReactNode;
  data: T[];
  id: string;
  search?: string;
  setSearch?(val: string): void;
  selectedTags?: Array<TagWithCategory>;
  setSelectedTags?: React.Dispatch<React.SetStateAction<TagWithCategory[]>>;
}

function TabTitleRender(props: ITabConfig<any>) {
  return (
    <div className={styles.tab}>
      <div>
        <FontAwesomeIcon icon={['fas', props.icon]} />
      </div>
      <div>{props.title}</div>
    </div>
  );
}

export default TabTitleRender;
